import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseCore";

const buildQueryParams = ({ search, active, users }) => {
    return {
        filter: search,
        filtroAtivo: active,
        usuarios: users
    };
};

export default Object.assign(
    {
        apiUrl: "/local",
        urlAdmin: "/local",

        async load({ pagination, filters = { search: "" } }) {
            const url = this.userUrl({ path: `/filter/${pagination.page}` });

            const query = buildQueryParams(filters);

            return await Vue.http.get(url, {
                params: query
            });
        },

        async loadEstablishiments({
            establishmentIds = [],
            pagination,
            filters = { search: "" }
        }) {
            const url = this.userUrl({
                path: `/filter-advertiser/${pagination.page}`
            });

            return Vue.http.post(url, establishmentIds, {
                params: {
                    filter: filters.search
                }
            });
        },

        async alterPosition({ id, dest }) {
            const url = this.userUrl({ path: `/${id}/position/${dest}` });

            return Vue.http.put(url);
        },

        async create(data) {
            const url = this.userUrl();

            const newLocal = await Vue.http.post(`${url}/`, data);

            return newLocal;
        },

        async get(id) {
            const url = this.userUrl({ path: `/${id}` });

            const local = await Vue.http.get(url);

            return local;
        },

        async update({ id, data }) {
            const url = this.url();

            const updateLocal = await Vue.http.put(`${url}/${id}`, data);

            return updateLocal;
        },

        async delete({ id }) {
            const url = this.userUrl({ path: `/${id}` });

            return Vue.http.delete(url);
        },

        async status({ id, userId }) {
            const url = this.userUrl({
                path: `/${id}/status`,
                userId
            });

            return Vue.http.put(url);
        },

        async getPossibleLogins({ id, userId } = {}) {
            const url = userId
                ? this.userUrl({ userId, path: `/${id}/tipos-login` })
                : this.adminUrl(`/tipos-login/allowed`);

            return Vue.http.get(url);
        },

        async getCategories() {
            const url = this.url('/categories')

            return Vue.http.get(url);
        },

        async alterLoginTypes({ id, userId, possibleLogins }) {
            const url = userId
                ? this.userUrl({ userId, path: `/${id}/tipos-login` })
                : this.adminUrl(`/tipos-login/allowed`);

            return Vue.http.put(url, possibleLogins);
        },

        async activateWifeed({ id }) {
            return Vue.http.put(`/${id}/enable-wifeed`);
        },

        async deactivateWifeed({ id }) {
            return Vue.http.put(`/${id}/disable-wifeed`);
        },

        async refreshReleseadIps(id) {
            const url = this.adminUrl(`/${id}/released/adddress/refresh`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.post(url, {}).catch(error => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        async cleanReleseadIps(id) {
            const url = this.adminUrl(`/${id}/released/adddress/clean`);
            EventBus.$emit("SHOW_SPINNER");
            const response = await Vue.http.post(url, {}).catch(error => {
                EventBus.$emit("CANCEL_SPINNER");
                throw error;
            });
            EventBus.$emit("CANCEL_SPINNER");
            return response;
        },

        releasedIps(id) {
            return Vue.http.get(this.adminUrl(`/${id}/released/adddress`));
        },

        async uploadConfig({ data }) {
            const url = this.userUrl({ path: `/local-config` });
            const options = {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            };

            return await Vue.http.post(url, data, options);
        }
    },
    base
);
